/** CMS 若二次转义为 &lt;p&gt;…，innerHTML 会按纯文本显示标签；仅在疑似实体编码时解码 */
function decodeHtmlEntitiesIfNeeded(text: string): string {
  if (!/&lt;\s*[a-z]/i.test(text)) return text;
  if (typeof document === 'undefined') return text;
  const el = document.createElement('textarea');
  el.innerHTML = text;
  return el.value;
}

function looksLikeCmsHtmlBody(text: string): boolean {
  const t = text.trim();
  if (!t) return false;
  if (/^<\s*(p|div|section|article|h[1-6]|ul|ol|table|figure|blockquote|span)\b/i.test(t)) {
    return true;
  }
  if (/<\s*p[\s>]|<\s*div[\s>]/i.test(text) && /<\s*\/\s*(p|div)\s*>/i.test(text)) {
    return true;
  }
  return false;
}

function isMarkdownDerivedBlockLine(trimmed: string): boolean {
  return (
    trimmed.startsWith('<h2') ||
    trimmed.startsWith('<h3') ||
    trimmed.startsWith('<h1') ||
    trimmed.startsWith('<h4') ||
    trimmed.startsWith('<h5') ||
    trimmed.startsWith('<h6') ||
    trimmed.startsWith('<ul') ||
    trimmed.startsWith('<blockquote') ||
    trimmed.startsWith('<li') ||
    trimmed.startsWith('<p') ||
    trimmed.startsWith('<div') ||
    trimmed.startsWith('<section') ||
    trimmed.startsWith('<article') ||
    trimmed.startsWith('<figure') ||
    trimmed.startsWith('<table')
  );
}

export function parseMarkdownContent(raw: string): string {
  const normalized = decodeHtmlEntitiesIfNeeded(raw);
  if (looksLikeCmsHtmlBody(normalized)) {
    return normalized;
  }

  let html = normalized
    .replace(/^## (.+)$/gm, '<h2>$1</h2>')
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/^> (.+)$/gm, '<blockquote>$1</blockquote>')
    .replace(/^- (.+)$/gm, '<li>$1</li>')
    .replace(/^\d+\. (.+)$/gm, '<li>$1</li>');
  html = html.replace(/(<li>.*<\/li>\n?)+/g, (match) => `<ul>${match}</ul>`);
  const lines = html.split('\n');
  const result: string[] = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue;
    if (isMarkdownDerivedBlockLine(trimmed)) {
      result.push(trimmed);
    } else {
      result.push(`<p>${trimmed}</p>`);
    }
  }
  return result.join('');
}
